import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import Calendar from 'react-calendar';
import GlobalContext from "../context/GlobalContext";
import { HomeFeaturedList } from "../utils/GetAPIUtils";
import Header from "../components/Header/MinHeader";
import Footer from "../components/Footer/MinFooter";
import "../style/css/style.css";
import "../style/css/media.css";

import "../style/css/common.css";
import { useLocation } from 'react-router-dom';
export default function MainPage() {
    const gContext = useContext(GlobalContext);
    const [featuredData, setFeaturedData] = useState(null);
    const pathName = useLocation().pathname.toLowerCase();
    const imgM = "/images/syncuppro-logo.svg";
    const hide = true;
    async function getHomeFeatureData() {
        try {

            const result = await HomeFeaturedList();

            if (result.data.homeFeaturedList.responseData.code == "200") {

                let data = JSON.parse(result.data.homeFeaturedList.responseData.message);

                setFeaturedData(data);
            }

        }
        catch (e) {

        }
    }
    useEffect(() => {
        document.title = "Regulatory Services & IT Compliance Outsourcing Consultants";
        const user = localStorage.getItem('connect');
        if (user == null && pathName.trim().toLowerCase() == "/login") {

            gContext.toggleSignInModal();
        }
        if (user == null && pathName.trim().toLowerCase() == "/signup") {
            gContext.toggleSignUpModal();
        }
        if (user == null && (pathName.trim().toLowerCase() == "/signupsuccess" || pathName.trim().toLowerCase() == "/signupsuccess_expert" || pathName.trim().toLowerCase() == "/signupsuccess_client") && localStorage.getItem('userEmail')) {
            gContext.toggleSignUpModal();
        }

        if (user == null && localStorage.getItem('userEmail') && (pathName.trim().toLowerCase() == "/signupcode" || pathName.trim().toLowerCase() == "/signupcode_expert" || pathName.trim().toLowerCase() == "/signupcode_client")) {
            gContext.toggleSignUpModal();
        }
        else if (pathName.trim().toLowerCase() == "/signupcode") {
            window.location.href = "/";
        }
        if (window.location.href.split('#').length > 1)
            window.location.href = window.location.href.replace(window.location.origin, "");

        const passwordChanged = localStorage.getItem('passwordChanged');
        if (passwordChanged) {
            localStorage.removeItem('passwordChanged');
            gContext.toggleSuccessModal();
        }
        getHomeFeatureData();

    }, [])

    return (
        <>
            <Helmet>
                <title>Regulatory Services & IT Compliance Outsourcing Consultants</title>
                <meta property="og:title" content="Regulatory Services & IT Compliance Outsourcing Consultants" />
                <meta name="twitter:title" content="Regulatory Services & IT Compliance Outsourcing Consultants" />
                <meta name="description" content="Expert IT compliance consultants offering regulatory compliance consulting, outsourcing, and professional guidance to ensure smooth business operations." />
                <meta name="og:description" content="Expert IT compliance consultants offering regulatory compliance consulting, outsourcing, and professional guidance to ensure smooth business operations." />
                <meta name="twitter:description" content="Expert IT compliance consultants offering regulatory compliance consulting, outsourcing, and professional guidance to ensure smooth business operations." />
                <meta name="keywords" content="it compliance consultant, compliance professionals, regulatory compliance consultants, regulatory compliance consulting services, compliance outsourcing" />
            </Helmet>
            <Header/>
                <div className="page-wrapper">

                    <section className="section welcome-sec bg-gray p-relative gradient-img bg-gray">
                        <div className="left-sec bg-gray text-center p-10 ">
                            <div className="section-title  m-10 p-10 text-center  "  >

                                <h1> Top IT <span className="text-theme">Consultant & Regulatory Compliance Professional</span> Services</h1>
                                <p className="section-desc p-10  p-l-50 p-r-50 ">Connect with pre-vetted ISO, cybersecurity, FDA, and CMMI specialists ready to step in.<br/> Save 30-50% vs. traditional firms and pay nothing until you hire.</p>
                            <div className="d-grid w-full   p-20  text-center "  >    <button className="btn btn-green btn-block  w-250 m-auto pointer p-t-15 p-b-15 f-20" type="button" onClick={() => { window.open(process.env.REACT_APP_ONCEHUB, "_blank"); }}>Book a Call</button>
                                </div>

                            </div>


                        </div>

                        <div className="right-sec">
                            <div className="img-wrapper">
                                <img className="img-block" src="images/find-compliance.jpg" alt="image" />
                            </div>
                        </div>
                    </section>

                    <><div className="section how-it-works p-b-80 p-relative bg-gray">
                        <span className="bg-wrap"></span>
                        <div className="container">

                            <div className="section-title m-b-20">
                                <h2>Specialized <span className="text-theme">Experts </span> Available</h2>
                            </div>

                            <div className="expert-group-wrapper m-t-20 w-full">
                                <div className="tab-content">


                                    <div id="experts" className={`tab-pane active show `} role="tabpanel">
                                        <div className="step-wrapper">

                                            <div className="card step-block p-relative ">
                                                <img src="images/iso1.png" alt="create-profile" />
                                                    <h6>Consultants</h6>

                                               
                                            </div>
                                            <div className="card step-block p-relative">
                                                <img src="images/training.jpg" alt="post-requ" />
                                                    <h6>Trainers</h6>

                                              
                                            </div>

                                            <div className="card step-block p-relative">
                                                   <img src="images/get-hiried.svg" alt="get-hiried" />
                                                    <h6 className="w-full">Certification/Appraisal Body</h6>

                                                
                                            </div>
                                            <div className="card step-block p-relative">
                                                  <img src="images/compliance.png" alt="get-hiried" />
                                                    <h6>Auditors</h6>

                                                
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    </>
                    <section className="section ideal-group p-relative p-t-50 ">


                        <div className="frame-content-block ">
                            <div className="section-title">

                                <h2 className="p-b-5">Why <span className="text-theme">Syncuppro</span>?</h2>
                            </div>

                            <div className="frame-block">
                                <img src="images/compliance-experts-profiles.svg" alt="compliance-experts-profiles" />
                                <div className="frame-data">
                                    <h6>Hire in Days, Not Months:</h6>
                                    <p className="m-0">With compliance-experts-profiles, you can fill critical compliance roles in just days — not months. Skip the slow, expensive consulting process and connect instantly with compliance experts ready to start. Whether you need an ISO lead auditor, InfoSec consultant, or Compliance Project Manager, our platform makes hiring simple and fast.</p>
                                </div>
                            </div>

                            <div className="frame-block">
                                <img src="images/multiple-proposal.svg" alt="multiple-proposal" />
                                <div className="frame-data">
                                    <h6>Pre-Vetted Specialists:</h6>
                                    <p className="m-0">Every professional listed under compliance-experts-profiles is rigorously screened and certified. Gain immediate access to a network of proven Compliance Experts, Compliance Managers, and Compliance Project Managers with credentials in ISO, FDA, InfoSec, CMMI, and more. Only top talent makes the cut.</p>
                                </div>
                            </div>

                            <div className="frame-block">

                                <span className="text-theme m-icon material-icons m-r-15 font-72 font-weight-semibold   ">paid</span>
                                <div className="frame-data">
                                    <h6>Pay Only When You Hire:</h6>
                                    <p className="m-0">When you use compliance-experts-profiles, there are no upfront costs or retainers. It's 100% risk-free — you only pay once you've successfully hired the right compliance professional for your project.</p>
                                </div>
                            </div>

                            <div className="frame-block">
                                <img src="images/percentage-percent.svg" style={{ width: "64px" }} alt="percentage-percent" />

                                <div className="frame-data">
                                    <h6>30-50% Cost Savings:</h6>
                                    <p className="m-0">Enjoy transparent pricing and significant savings. Hiring through compliance-experts-profiles typically costs 30-50% less than traditional consultancies or recruiters, helping you get expert compliance support without draining your budget.</p>
                                </div>
                            </div>

                            <div className="frame-block">
                                <img src="images/project-tracking.svg" alt="project-tracking" />
                                <div className="frame-data">
                                    <h6>Avoid Compliance Pitfalls:</h6>
                                    <p className="m-0">Don't let compliance issues derail your business. Studies show that 41% of companies report sales delays due to poor compliance readiness, and audit failures can cost million-dollar deals. With compliance-experts-profiles, you can prevent costly setbacks by matching with the right expert at the right time.</p>
                                </div>
                            </div>


                        </div>

                    <div className="m-auto  w-resp-half ">   <div className=" m-r-20 m-l-20  text-center  m-b-30 section-title">
                        <h5 className="text-center pointer" onClick={() => { window.open(process.env.REACT_APP_ONCEHUB, "_blank") }}><span className="text-green">Free 30-Minute </span>  Compliance Hiring Strategy Call </h5>
                        <h3 className=" text-center pointer" onClick={() => { window.open(process.env.REACT_APP_ONCEHUB, "_blank") }}>Plan your next hire with  <span className="text-theme"> expert </span> insight - in just one call</h3>
                        <p> Get role clarity, real-time market benchmarks, and a shortlist gameplan - all before the session ends.</p>
                    </div> <div className="m-auto m-b-50  m-t-40 pointer  card p-0 calender-width" data-toggle="tooltip" title="Click to Book a call" onClick={() => { window.open(process.env.REACT_APP_ONCEHUB, "_blank") }}> <Calendar /></div>
                        <div className=" m-r-20 m-l-20   m-b-30 section-title">  <h6>  What you get on the call:</h6>
                            <ul className="policy-list m-t-10 m-l-10">
                                <li className="m-b-5">
                                    
                                    <span>
                                        <b> <span className="m-icon material-icons f-11 m-r-10">circle</span>Define the role </b> - scope, budget, timeline, and hiring goals
                                    </span>
                                </li>
                                <li className="m-b-5">
                                    
                                    <span>
                                        <b><span className="m-icon material-icons f-11 m-r-10">circle</span>See live data</b>  - current day rates & time-to-hire for similar roles
                                    </span>
                                </li>
                                <li className="m-b-5">
                                    
                                    <span>
                                        <b> <span className="m-icon material-icons f-11 m-r-10">circle</span>Walk away ready</b>  - we send you 5 vetted expert profiles within 24 hours
                                    </span>
                                </li> 
                            </ul>
                        </div> 
                    </div>
                   </section>

            </div>
            <Footer/>
          
        </>
    );
};

